import styled from 'styled-components'

export const Section = styled.section`
  width: 100%;
  display: grid;
  gap: 18px;
  margin-top: 20px;
`

export const ReactionPanel = styled.div`
  padding: 20px;
  border: 1px solid #ececec;
  border-radius: 18px;
  background: #fff;

  > div:first-child {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  > div:first-child strong {
    color: #242424;
    font-size: 18px;
  }

  > div:first-child span {
    color: #888;
    font-size: 11px;
  }
`

export const ReactionList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
  margin-top: 15px;
`

export const ReactionButton = styled.button<{ $selected?: boolean }>`
  min-height: 44px;
  padding: 7px 12px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border: 1px solid ${({ $selected }) => ($selected ? '#e00000' : '#e4e4e4')};
  border-radius: 999px;
  background: ${({ $selected }) => ($selected ? '#fff4f4' : '#fff')};
  color: ${({ $selected }) => ($selected ? '#c90000' : '#4d4d4d')};
  cursor: pointer;
  transition:
    border-color 0.18s ease,
    background 0.18s ease,
    transform 0.18s ease;

  &:hover {
    border-color: #e00000;
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.65;
    cursor: wait;
  }

  > span {
    font-size: 18px;
  }

  > strong {
    font-size: 11px;
  }

  > small {
    min-width: 22px;
    height: 22px;
    padding: 0 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 999px;
    background: #f4f4f4;
    font-size: 9px;
    font-weight: 800;
  }
`

export const CommentsPanel = styled.div`
  padding: 20px;
  border: 1px solid #ececec;
  border-radius: 18px;
  background: #fff;
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;

  > div:first-child {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  > div:first-child strong {
    color: #242424;
    font-size: 18px;
  }

  > div:first-child span {
    color: #888;
    font-size: 11px;
  }

  @media (max-width: 700px) {
    flex-direction: column;
  }
`

export const Sort = styled.div`
  display: flex;
  gap: 5px;
  padding: 3px;
  border-radius: 999px;
  background: #f5f5f5;

  button {
    min-height: 30px;
    padding: 0 10px;
    border: 0;
    border-radius: 999px;
    background: transparent;
    color: #777;
    font-size: 9px;
    font-weight: 800;
    cursor: pointer;
  }

  button.active {
    background: #fff;
    color: #d00000;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.07);
  }
`

export const Composer = styled.div`
  display: grid;
  grid-template-columns: 42px 1fr;
  gap: 11px;
  margin-top: 18px;
  padding: 14px;
  border: 1px solid #ededed;
  border-radius: 14px;
  background: #fafafa;

  > div {
    min-width: 0;
  }

  textarea {
    width: 100%;
    min-height: 86px;
    resize: vertical;
    padding: 10px 11px;
    border: 1px solid #e2e2e2;
    border-radius: 10px;
    outline: none;
    background: #fff;
    color: #333;
    font-family: inherit;
    font-size: 12px;
    line-height: 1.5;
  }

  textarea:focus {
    border-color: #e00000;
    box-shadow: 0 0 0 3px rgba(224, 0, 0, 0.06);
  }

  textarea:disabled {
    background: #f3f3f3;
  }
`

export const Avatar = styled.img`
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
  background: #f3f3f3;
`

export const ComposerFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 7px;

  small {
    color: #aaa;
    font-size: 9px;
  }

  button {
    min-height: 34px;
    padding: 0 14px;
    border: 0;
    border-radius: 999px;
    background: #e00000;
    color: #fff;
    font-size: 10px;
    font-weight: 800;
    cursor: pointer;
  }

  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`

export const CommentList = styled.div`
  display: grid;
  gap: 12px;
  margin-top: 18px;
`

export const CommentCard = styled.article<{ $reply?: boolean }>`
  padding: ${({ $reply }) => ($reply ? '12px 13px' : '15px')};
  border: 1px solid #ededed;
  border-radius: 14px;
  background: ${({ $reply }) => ($reply ? '#fafafa' : '#fff')};
`

export const CommentHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
`

export const CommentIdentity = styled.div`
  min-width: 0;
  flex: 1;

  > strong {
    color: #282828;
    font-size: 12px;
  }
`

export const IdentityMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 3px;

  span {
    color: #999;
    font-size: 8px;
  }

  span.verified,
  span.author {
    padding: 3px 6px;
    border-radius: 999px;
    font-weight: 800;
  }

  span.verified {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    background: #fff2f2;
    color: #cf0000;
  }

  span.author {
    background: #f0f7ff;
    color: #27659e;
  }
`

export const PendingBadge = styled.span`
  padding: 5px 8px;
  border-radius: 999px;
  background: #fff6db;
  color: #8b6b00;
  font-size: 8px;
  font-weight: 800;
`

export const CommentText = styled.p`
  margin: 10px 0 0;
  color: #4a4a4a;
  font-size: 12px;
  line-height: 1.6;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`

export const CommentActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 11px;
  margin-top: 9px;

  button {
    padding: 0;
    border: 0;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: transparent;
    color: #8a8a8a;
    font-size: 9px;
    font-weight: 700;
    cursor: pointer;
  }

  button:hover {
    color: #d00000;
  }
`

export const ReplyComposer = styled.div`
  margin-top: 11px;
  padding: 10px;
  border-radius: 11px;
  background: #f8f8f8;

  textarea {
    width: 100%;
    min-height: 70px;
    resize: vertical;
    padding: 9px;
    border: 1px solid #dfdfdf;
    border-radius: 9px;
    font-family: inherit;
    font-size: 11px;
  }

  > div {
    margin-top: 7px;
    display: flex;
    justify-content: flex-end;
    gap: 7px;
  }

  button {
    min-height: 30px;
    padding: 0 10px;
    border: 1px solid #dedede;
    border-radius: 999px;
    background: #fff;
    color: #666;
    font-size: 9px;
    font-weight: 700;
    cursor: pointer;
  }

  button.primary {
    border-color: #e00000;
    background: #e00000;
    color: #fff;
  }
`

export const EditArea = styled(ReplyComposer)``

export const Replies = styled.div`
  display: grid;
  gap: 8px;
  margin-top: 12px;
  margin-left: 36px;

  @media (max-width: 600px) {
    margin-left: 14px;
  }
`

export const MoreReplies = styled.button`
  width: max-content;
  padding: 4px 0;
  border: 0;
  background: transparent;
  color: #c90000;
  font-size: 9px;
  font-weight: 800;
  cursor: pointer;
`

export const ReportBox = styled.div`
  display: flex;
  gap: 7px;
  margin-top: 10px;

  select,
  button {
    min-height: 32px;
    border: 1px solid #dddddd;
    border-radius: 8px;
    background: #fff;
    font-family: inherit;
    font-size: 9px;
  }

  select {
    min-width: 170px;
    padding: 0 8px;
  }

  button {
    padding: 0 10px;
    color: #c80000;
    font-weight: 800;
    cursor: pointer;
  }
`

export const State = styled.div`
  margin-top: 17px;
  padding: 20px;
  border-radius: 12px;
  background: #fafafa;
  color: #999;
  font-size: 10px;
  text-align: center;
`

export const LoadMore = styled.button`
  display: block;
  min-height: 36px;
  margin: 16px auto 0;
  padding: 0 15px;
  border: 1px solid #dddddd;
  border-radius: 999px;
  background: #fff;
  color: #666;
  font-size: 10px;
  font-weight: 800;
  cursor: pointer;
`
